import React from 'react'

import clsx from 'clsx'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SyncIcon from '@mui/icons-material/Sync';
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { Button, IconButton, Tooltip } from '@mui/material';
import { lighten, makeStyles } from '@material-ui/core';
import { Colors } from '../../styles/theme';

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(Colors.danger, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}))

const TableToolbar = props => {
  const classes = useToolbarStyles();
  const {
    numSelected,
    addRecordHandler,
    deleteRecordHandler,
    syncData,
    // New optional props for custom selected actions
    selectedRows = [],
    selectedToolbarActions = [],
    onClearSelection,
  } = props
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >

      {deleteRecordHandler && numSelected > 0 && (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
        >
          {numSelected} selected
        </Typography>
      )}

      {numSelected > 0 ? (
        <>
          {/* Default delete action (if provided) */}
          {deleteRecordHandler && (
            <Tooltip title="Delete">
              <IconButton aria-label="delete" onClick={deleteRecordHandler}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* Custom selected actions */}
          {Array.isArray(selectedToolbarActions) && selectedToolbarActions.map((action) => {
            const { id, label, icon, onClick, tooltip, variant = 'icon', color = 'primary' } = action;
            const key = id || label;
            const handleClick = () => {
              try {
                onClick && onClick(selectedRows, { clearSelection: onClearSelection });
              } catch (e) {
                // swallow UI handler errors
                console.error('Toolbar action error:', e);
              }
            };
            const content = variant === 'button' ? (
              <Button key={key} onClick={handleClick} color={color} startIcon={icon} sx={{ ml: 1 }}>
                {label}
              </Button>
            ) : (
              <IconButton key={key} onClick={handleClick} color={color} sx={{ ml: 1 }}>
                {icon}
              </IconButton>
            );
            return tooltip ? (
              <Tooltip key={`${key}-tt`} title={tooltip}>
                <span>{content}</span>
              </Tooltip>
            ) : content;
          })}

        </>

      ) : (
        <>
          {addRecordHandler && <Button onClick={addRecordHandler} variant="outlined" startIcon={<AddIcon />}>Add</Button>}
          {/* we don't need this since we have filter at column level
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
          /> */}
          <IconButton onClick={() => syncData()}>
            <Tooltip title="Refresh">
              <SyncIcon fontSize="small" sx={{ ml: 1, color: Colors.dim_grey }} />
            </Tooltip>
          </IconButton>
        </>

      )}
    </Toolbar>
  )
}

// TableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
//   addUserHandler: PropTypes.func.isRequired,
//   deleteUserHandler: PropTypes.func.isRequired,
//   setGlobalFilter: PropTypes.func.isRequired,
//   preGlobalFilteredRows: PropTypes.array.isRequired,
//   globalFilter: PropTypes.string.isRequired,
// }

export default TableToolbar
